/**
 * HelpAboutSheet
 *
 * Displays Help & About items (Contact, Support, Legal documents,
 * About Expause) and an app-version footer. (Share and Feedback exist in the
 * Flutter list but were removed from the web variant — moved into
 * `HomeTopBarBody`; see `helpAboutEntity.ts`.) Tapping a row navigates to the
 * corresponding page (e.g. the ABOUT row pushes `/about`); the sheet stays
 * open across the route push per project convention.
 *
 * Flutter source: lib/presentation/screens/settings/app_settings_screen.dart
 * (items list, excluding logout/deleteAccount).
 */

import { SheetService } from '../service/SheetService';
import { HelpAboutContent } from './components/HelpAboutContent';

/**
 * Configuration for showing the Help & About sheet
 */
export interface HelpAboutSheetConfig {
  /** Optional container element, screen key string, or null */
  container?: HTMLElement | string | null;

  /** Optional screen key of the route opening this sheet */
  screenKey?: string;

  /** Force the sheet to render as a dialog instead of a bottom sheet */
  forceDialog?: boolean;
}

/**
 * Show a Help & About sheet.
 *
 * @param config - Configuration for the sheet
 * @returns Promise that resolves when the sheet is dismissed
 *
 * @example
 * await HelpAboutSheet.show({ screenKey });
 */
const show = (config: HelpAboutSheetConfig = {}): Promise<void> => {
  return new Promise((resolve) => {
    SheetService.show({
      content: <HelpAboutContent />,
      onClose: resolve,
      closeOnClickOutside: true,
      container: config.container,
      screenKey: config.screenKey,
      forceDialog: config.forceDialog,
      qaId: 'help-about',
    });
  });
};

export const HelpAboutSheet = {
  show,
};
